import { render, staticRenderFns } from "./info-account.vue?vue&type=template&id=195304e6&"
import script from "./info-account.vue?vue&type=script&lang=js&"
export * from "./info-account.vue?vue&type=script&lang=js&"
import style0 from "./info-account.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports